define('PubSub',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PubSub = /** @class */ (function () {
        function PubSub() {
            this.events = {};
        }
        PubSub.prototype.publish = function (name, args) {
            var _this = this;
            var handlers = this.events[name];
            if (handlers === undefined)
                return;
            handlers.forEach(function (handler) {
                handler.call(_this, args);
            });
        };
        PubSub.prototype.subscribe = function (name, handler) {
            var handlers = this.events[name];
            if (handlers === undefined) {
                handlers = this.events[name] = [];
            }
            handlers.push(handler);
        };
        PubSub.prototype.unsubscribe = function (name, handler) {
            var handlers = this.events[name];
            if (handlers === undefined)
                return;
            var handlerIdx = handlers.indexOf(handler);
            handlers.splice(handlerIdx);
        };
        PubSub.prototype.dispose = function () {
            this.events = {};
        };
        return PubSub;
    }());
    exports.PubSub = PubSub;
});
//# sourceMappingURL=PubSub.js.map
